import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { GenericRESTPagedClientManager } from "../../../../js/lib/manager/GenericRESTPagedClientManager";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";


export const FinesClientManager = function() {
  let instance = null;
  return {
    getInstance: (options) => {
      if(instance){
        return instance;
      }
      instance = new FinesClientManagerClass(options);
      return instance;
    }
  }
}();
class FinesClientManagerClass extends GenericRESTPagedClientManager {
  constructor(options) {
    super(
      $.extend(
        {
          resultsPanelId: options.resultsPanelId,
          restUrl: LS2PAC_CONSTANTS.restUrls.getFines,
          pageSize: 10000,
        },
        options
      )
    );

    this.restOptions.cancellable = true;
    this.restOptions.cache = false;
    this.sortField = this.defaultSort = "OutDate";
    this.addListeners();
  }
  fireSearch(event) {
    this.search(
      this.currentPage * this.pageSize,
      this.pageSize,
      this.sortField
    );
  }
  resetPageCache() {
    this.pages = [];
    this.hasResults = false;
    this.currentPage = 0;
  }
  setTotalHits(totalHits) {
    this.resetPageCache();
    this.totalHits = totalHits;
  }
  addListeners() {
    var _this = this;

    TLCEventManager.addListener(this.searchEvent, function (event) {
      _this.resetPageCache();
      _this.fireSearch(event);
      _this.addHistory(event);
    });

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onLogoutResponse,
      function (event) {
        _this.sortField = _this.defaultSort;
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onGetAllFines,
      function (event) {
        var success = false,
          response = {};
        TLCRest.jsonCall(
          [
            LS2PAC_CONSTANTS.restUrls.getFines,
            0,
            _this.pageSize,
            _this.sortField,
            "false",
          ].join("/"),
          {
            callback: function (data) {
              success = true;
              response = data.fees;
              TLCLogger.log("onGetAllFines response", data);
            },
            finallyHandler: function () {
              TLCEventManager.fireEvent(
                LS2PAC_CONSTANTS.Events.onGetAllFinesResponse,
                { success: success, data: response }
              );
            },
            timeout: 30000,
            cancellable: true,
            cache: false,
          }
        );
      }
    );
  }
}
